<form
  [formGroup]="outputForm"
  (ngSubmit)="saveOutput()"
  autocomplete="on"
  class="container-grid"
  [ngStyle]="containerStyles"
>
  <div class="grid-first">
    <label for="tipo-salida-opcion" class="form-label">Tipo de salida*</label>
    <select
      id="tipo-salida-opcion"
      class="form-control"
      [formControl]="outputType"
    >
      <option *ngFor="let item of outputTypes" [value]="item.id">
        {{ item.description }}
      </option>
    </select>
  </div>
  <div *ngIf="movimiento !== 'crear'">
    <label for="noOperacion" class="form-label">No. de operación*</label>
    <input
      type="number"
      id="noOperacion"
      class="form-control"
      [value]="outputDetail[0].id || 0"
      disabled
    />
  </div>
  <div>
    <label for="clave-recinto" class="form-label">Clave del recinto*</label>
    <input
      type="number"
      id="clave-recinto"
      class="form-control"
      formControlName="precinct_key"
    />
  </div>
  <div>
    <label for="fechaRecinto" class="form-label">Fecha de salida*</label>
    <input
      type="date"
      id="fechaRecinto"
      class="form-control"
      formControlName="departure_date"
    />
    <span
      class="form-text text-danger"
      *ngIf="isValidField('departure_date')"
    >
      Ingrese la fecha
    </span>
  </div>
  <div>
    <label for="nombreChecador" class="form-label">Nombre del checador*</label>
    <input
      type="text"
      id="nombreChecador"
      class="form-control"
      formControlName="checker_name"
      maxlength="200"
    />
    <span
      class="form-text text-danger"
      *ngIf="isValidField('checker_name')"
    >
      Ingrese el nombre del checador
    </span>
  </div>
  <div class="grid-first">
    <label for="location_id" class="form-label">Ubicación de origen*</label>
    <select
        id="location_id"
        class="form-control"
        formControlName="location_id"
        (change)="changeLocation()"
      >
      <option value="">-- Seleccione la Ubicación --</option>
      <option *ngFor="let location of locationsFiltered" [value]="location.id" [disabled]="location.disabled">
        {{ location.description }}
      </option>
    </select>
    <span class="form-text text-danger" *ngIf="isValidField('location_id')">
      Selecciona la ubicación
    </span>
  </div>
  <div class="d-flex gap-3">
    <div class="w-100">
      <label for="locationTonsPerYard" class="form-label">Tonelaje de la ubicación*</label>
      <input
        type="text"
        id="locationTonsPerYard"
        class="form-control"
        formControlName="location_tonnage"
      >
    </div>
    <div class="w-100">
      <label for="locationPiecesPerYard" class="form-label">Piezas de la ubicación*</label>
      <input
        type="text"
        id="locationPiecesPerYard"
        class="form-control"
        formControlName="location_pieces"
      >
    </div>
  </div>
  <div class="subtitle">
    <div class="d-flex">
      <h2 class="title mb-3">Transferir tonelaje entre patios</h2>
      <i class="bi bi-plus-circle" (click)="addLocation()" *ngIf="movimiento !== 'detalle'"></i>
    </div>
  </div>
  <ng-container formArrayName="location_list">
    <ng-container *ngFor="let location of locationArray['controls']; let i=index" [formGroupName]="i">
      <div class="grid-first">
        <label for="ubicacion-{{ i }}" class="form-label">Ubicación destino*</label>
        <select
            id="ubicacion-{{ i }}"
            class="form-control"
            formControlName="location_id"
          >
          <option value="">-- Seleccione la Ubicación --</option>
          <option *ngFor="let location of destinyLocation" [value]="location.id" [disabled]="location.disabled">
            {{ location.description }}
          </option>
        </select>
        <span class="form-text text-danger" *ngIf="isValidArray(i, 'location_id')">
          Selecciona la ubicación
        </span>
      </div>
      <div>
        <label for="tonsPerYard-{{ i }}" class="form-label">Tonelaje a transferir*</label>
        <input
          type="text"
          id="tonsPerYard-{{ i }}"
          class="form-control"
          formControlName="tonnage"
          maxlength="15"
          appBlockLetters
        >
        <span class="form-text text-danger" *ngIf="isValidArray(i, 'tonnage') && !location.errors?.tonnageExceeds">
          Ingresa un tonelaje positivo y con máximo tres decimales
        </span>
      </div>
      <div class="d-flex">
        <div class="w-100">
          <label for="piecesPerYard-{{ i }}" class="form-label">Piezas a transferir*</label>
          <input
            type="text"
            id="piecesPerYard-{{ i }}"
            class="form-control"
            formControlName="pieces"
            appOnlyNumbers
            [maxDigits]="10"
          >
          <span class="form-text text-danger" *ngIf="isValidArray(i, 'pieces') && !location.errors?.piecesExceeds">
            Ingrese el numero de piezas
          </span>
        </div>
        <i class="bi bi-trash3 ms-3 patios-size" *ngIf="movimiento !== 'detalle'" (click)="deleteLocation(i)"></i>
      </div>
    </ng-container>
  </ng-container>
  <div class="grid-first"></div>
  <div>
    <label for="tonelaje" class="form-label">Tonelaje total a transferir*</label>
    <input
      type="text"
      id="tonelaje"
      class="form-control"
      formControlName="total_tonnage"
    />
    <span class="form-text text-danger" *ngIf="outputForm.errors?.['tonnageExceeds']">
      El tonelaje debe ser menor o igual al de la ubicación de origen
    </span>
  </div>
  <div>
    <label for="no-piezas-totales" class="form-label"
      >Piezas totales a transferir*</label
    >
    <input
      type="text"
      id="no-piezas-totales"
      class="form-control"
      formControlName="total_pieces"
    />
    <span class="form-text text-danger" *ngIf="outputForm.errors?.['piecesExceeds']">
      El número de piezas debe ser menor o igual al de la ubicación de origen
    </span>
  </div>
  <div class="grid-first-span2">
    <label for="observaciones-embalaje" class="form-label">Observaciones</label>
    <input
      type="text"
      id="observaciones-embalaje"
      class="form-control"
      maxlength="150"
      formControlName="observations"
    />
    <span
      class="form-text text-danger"
      *ngIf="isValidField('observations')"
    >
      Ingrese las observaciones
    </span>
  </div>

  <div class="grid-all container-button">
    <button
      type="button"
      class="btn-lote me-5"
      (click)="regresar()"
      *ngIf="movimiento !== 'crear'"
    >
      Regresar
    </button>
    <button
      type="submit"
      class="btn-lote ms-5"
      *ngIf="movimiento !== 'detalle'"
    >
      Guardar
    </button>
  </div>
</form>
<app-overlay
  *ngIf="overlay"
  [icono]="overlayIcon"
  [mensaje]="overlayMessage"
  [buttons]="overlayButtons"
></app-overlay>
<app-overlay
  *ngIf="loading"
></app-overlay>
<app-overlay
*ngIf="overlayError"
[reload]="true"
></app-overlay>
